import React from 'react';
import { Button } from 'reactstrap';
export const ButtonAction = ({ text, onClick = () => {}, type = 'submit' }) => {
  return (
    <Button color="primary" type={type} onClick={onClick}>
      {text}
    </Button>
  );
};
